import type { ContentPost, PostFormat } from 'api/new-analytics/types';
import { PseudoPostType } from 'constants/post';

const POST_FORMAT_ALIASES: Record<string, PostFormat> = {
  reels: 'reel',
  image: 'photo',
  images: 'photo',
  carousel_album: 'carousel',
  status: 'text',
};

const POST_FORMAT_TO_PSEUDO: Record<PostFormat, PseudoPostType> = {
  photo: PseudoPostType.Photo,
  video: PseudoPostType.Video,
  carousel: PseudoPostType.Carousel,
  reel: PseudoPostType.Reel,
  short_video: PseudoPostType.Video,
  story: PseudoPostType.Story,
  text: PseudoPostType.Status,
  link: PseudoPostType.Link,
  document: PseudoPostType.Document,
};

function postFormatToPseudoType(rawFormat: string): PseudoPostType {
  const normalized = rawFormat.trim().toLowerCase();
  if (!normalized) {
    return PseudoPostType.Unknown;
  }
  const key = POST_FORMAT_ALIASES[normalized] ?? (normalized as PostFormat);
  return POST_FORMAT_TO_PSEUDO[key] ?? PseudoPostType.Unknown;
}

export function contentPostToPseudoPostType(post: ContentPost): PseudoPostType {
  if (post.entity_type === 'reel') {
    return PseudoPostType.Reel;
  }
  if (post.entity_type === 'story') {
    return PseudoPostType.Story;
  }
  const raw = typeof post.post_format === 'string' ? post.post_format : '';
  return postFormatToPseudoType(raw);
}

export function getContentPostRowPostType(post: ContentPost): PseudoPostType {
  const pseudoType = contentPostToPseudoPostType(post);
  const firstMedia = post.media?.[0];
  const isDocumentPost =
    firstMedia?.type?.toLowerCase() === 'document' ||
    pseudoType === PseudoPostType.Document;
  return isDocumentPost ? PseudoPostType.Document : pseudoType;
}
